import React from 'react'
import ReactCrop, { makeAspectCrop } from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

class CropModal extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			crop: {
				x: 0,
				y: 0,
			},
			maxHeight: 100,
			initWidth: 0,
			initHeight: 0,
			modalVisibility: false
	    }
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.imgURI !== this.props.imgURI && nextProps.imgURI !== '') {
			this.setState({
				modalVisibility: true
			})
			this.props.setDisable()
		}
	}
	
	handleCrop = () => {
        const croppedImg = this.state.pixelCrop.height == 0 && this.state.pixelCrop.width == 0 ? this.getCroppedImg(this.state.image, 'RET_FILE') : this.getCroppedImg(this.state.image, 'RET_FILE', this.state.pixelCrop);
		// document.getElementById("uploadedImage").src = croppedImg
		this.setState({
			modalVisibility: false
		})
		this.props.removeDisable()
    }
	
	getCroppedImg = (image, fileName, pixelCrop) => {
		const canvas = document.createElement('canvas')
		let pixelCropWidth = pixelCrop ? pixelCrop.width : this.state.initWidth
		let pixelCropHeight = pixelCrop ? pixelCrop.height : this.state.initHeight
		let pixelCropX = pixelCrop ? pixelCrop.x : 0
		let pixelCropY = pixelCrop ? pixelCrop.y : 0
		canvas.width = pixelCropWidth
		canvas.height = pixelCropHeight
		const ctx = canvas.getContext('2d')
		ctx.drawImage(
			image,
			pixelCropX,
			pixelCropY,
			pixelCropWidth,
			pixelCropHeight,
			0,
			0,
			pixelCropWidth,
			pixelCropHeight
		)
		let dataURI = canvas.toDataURL('image/jpeg');
		return this.resizer(dataURI, pixelCropWidth, pixelCropHeight)
	}
	
	resizer = (dataURI, w, h) => {
        let img = new Image;
        img.onload = () => {
	        var canvas = document.createElement('canvas'),
                max_size = 750,
                width = w,
                height = h;
            if (width > height) {
                if (width > max_size) {
                    height *= max_size / width;
                    width = max_size;
                }
            } else {
                if (height > max_size) {
                    width *= max_size / height;
                    height = max_size;
                }
            }
            canvas.width = width;
            canvas.height = height;
			canvas.getContext('2d').drawImage(img, 0, 0, width, height)
			document.getElementById("uploadedImageWrapper").classList.add('active')
			document.getElementById("uploadedImage").src = canvas.toDataURL('image/jpeg')
		};
        img.src = dataURI
	}
    
	onImageLoaded = (image) => {
		this.setState({
			crop: makeAspectCrop({
				x: 0,
				y: 0,
				aspect: 1 / 1,
				width: 50
			}, image.naturalWidth / image.naturalHeight),
			image,
			initWidth: image.naturalWidth / 2 || image.width / 2,
			initHeight: image.naturalWidth / 2 || image.width / 2
		})
    }

    onCropComplete = (crop, pixelCrop) => {
		this.setState({ pixelCrop })
    }

    onCropChange = (crop) => {
		this.setState({ crop });
    }
    
	render() {
		return (
			<div>
				{this.props.imgURI && this.state.modalVisibility &&
					<div className="crop_wrapper">
						<div className="crop_wrapper_inner">
							<div className="crop_wrapper_header">
							</div>
							<div className="crop_wrapper_body">
								<div className="crop_wrapper_canvas">
									<ReactCrop
							            {...this.state}
							            src={ this.props.imgURI }
							            onImageLoaded={this.onImageLoaded}
							            onComplete={this.onCropComplete}
							            onChange={this.onCropChange}
							            minHeight={25}
							        />
						        </div>
					        </div>
					        <div className="crop_wrapper_footer">
						        <button type="button" className="btn btn-crop" onClick={() => this.handleCrop()}>
						        	<span className="icon"><svg viewBox="0 0 513 512"><path d="M488 384h-40V99.2l61.9-61.7c4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0L415.3 64H128V24c0-13.3-10.7-24-24-24H88C74.7 0 64 10.7 64 24v40H24C10.7 64 0 74.7 0 88v16c0 13.3 10.7 24 24 24h40v296c0 13.3 10.7 24 24 24h296v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-40h40c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24zM351 128L128 350.2V128h223zM162 384l222-221.1V384H162z"></path></svg></span>
							        <span className="label">Crop Image</span>
						        </button>
							</div>
				        </div>
			        </div>
		        }
		    </div>
		)
	}
}

export default CropModal


// WEBPACK FOOTER //
// ./src/components/Modals/CropModal.js